import React from "react";

import { Row, Col } from "antd";

import { PriceFormInput } from "components/ratecard/_common";

interface EditItemProps {
  label: string;
  inputKey: string;
  name: Array<string>;
  currency: string;
}

export const EditItem: React.FC<EditItemProps> = ({ label, inputKey, name, currency }) => {
  return (
    <Row gutter={30}>
      <Col>
        <PriceFormInput label={label} name={name.concat([inputKey])}>
          <PriceFormInput.PriceInput />
        </PriceFormInput>
      </Col>
      <Col style={{ display: "flex", alignItems: "flex-end" }}>
        <PriceFormInput label="Currency">{currency}</PriceFormInput>
      </Col>
    </Row>
  );
};
